import React, { FC } from "react";
import styles from "./Tooltip.module.scss";
import { TooltipProps } from "./Tooltip.types";
import { Typography } from "../index";

const Tooltip: FC<TooltipProps> = ({ title, children, noOffset }) => {
  return (
    <span className={styles.tooltipContainer} data-testid="Tooltip">
      <span
        className={[
          styles.tooltip,
          noOffset ? styles.tooltipNoOffset : "",
        ].join(" ")}
      >
        <Typography variant={"p"} token={75} weight={"medium"}>
          {title}
        </Typography>
      </span>
      {children}
    </span>
  );
};

export default Tooltip;
